export default __webpack_public_path__ + "static/media/moon.efc3253b.svg";